import React, { useState } from 'react';
import { Button, useMediaQuery, useTheme } from '@material-ui/core';
import ContentWrap from '../atoms/ContentWrap';
import FormCard from './FormCard';
import FormMobile from './FormMobile';
import StyledModal from '../molecules/StyledModal';
import SpecialistContactYouModal from '../molecules/SpecialistContactYouModal';

export default function ButtonSwitchAccountantSectionMobile({
  tagSliderMobile,
  tagSliderMobileLigar,
  tagSliderMobileWpp,
  tagSliderMobileId,
  tagSliderMobileLigarId,
  tagSliderMobileWppId,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  if (!isMobile) {
    return null;
  }

  return (
    <>
      <ContentWrap>
        <Button
          id={tagSliderMobileId}
          onClick={() => {
            tagSliderMobile();
            setOpen(true);
          }}
          style={{
            marginTop: '70px', height: '52px', backgroundColor: '#0CB49D', color: '#FFFFFF',
          }}
        >
          QUERO MIGRAR PARA A CONUBE
        </Button>
      </ContentWrap>
      <StyledModal open={open} setOpen={setOpen}>
        <FormCard color="#0CB49D" title="Trocar contador">
          <FormMobile tagPhone={tagSliderMobileLigar} tagWhatsApp={tagSliderMobileWpp} tagPhoneId={tagSliderMobileLigarId} tagWhatsAppId={tagSliderMobileWppId} color="#0CB49D" hubspotAction="trocar-contador" onSuccess={() => setShowConfirmationModal(true)} />
        </FormCard>
      </StyledModal>
      <SpecialistContactYouModal
        isOpen={showConfirmationModal}
        handleClose={() => setShowConfirmationModal(false)}
        handleConfirm={() => { }}
      />
    </>
  );
}
